// 從現在時間開始計算 
// 傳入天數 正數往後計算 負數往前計算 
// 可以拿到對應的 毫秒單位的  timestamp
export function getTimestampByDays(days, fromTime = Date.now()) {
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  return fromTime + days * millisecondsPerDay;
}